import IndexPage from "flarum/components/IndexPage";
import DiscussionComposer from 'flarum/components/DiscussionComposer';
import TextEditor from 'flarum/components/TextEditor';
import Composer from 'flarum/components/Composer';
import LogInModal from 'flarum/components/LogInModal';
import { extend, override } from "flarum/common/extend";
import newsElementsMaker from "../helpers/newsElementsMaker";
import DiscussionListItem from 'flarum/forum/components/DiscussionListItem';

export default function () {
  // IndexPage.prototype.getTopQuestions = function() {
  //   const { topQuestions } = app.forum.data.attributes;
  // }
  extend(DiscussionListItem.prototype, 'view', function (vdom) {
    const hasBestAnswer = vdom.children[2].children[1].children.find(v => v.key === 'bestAnswer');
    if (hasBestAnswer) {
      vdom.attrs.className += ' hasBestAnswer';
    }
  });

  extend(IndexPage.prototype, "view", function (vnode) {
    // console.log(vnode);
    const rootElem = vnode.children[1];
    const { topQuestions } = app.forum.data.attributes;

    // const items = new ItemList();
    const title = app.translator.trans(
      "tolyod-advdiscus.forum.right_side_title"
    );
    const topQuestionsElem = newsElementsMaker(topQuestions, title, false);
    // console.log(topQuestions, topQuestionsElem, app.forum.data.attributes);
    rootElem.children.push(
      m("nav.DiscussionListRelatedQuestions",topQuestionsElem)
    );

  });

  override(Composer.prototype, "view", function(vnode) {
    const elem = vnode();
    const children = elem.children;
    elem.children[0] = m('div.spec-help-composer', children );
    elem.children[1] = null;
    elem.children[2] = null;
    elem.children[3] = null;
    return  elem;
  });

  override(DiscussionComposer.prototype, "headerItems", function(cb) {
    // const items = cb().headerItems();
    // console.log(cb());
    const items = cb();

    // items.replace('title', <h3>{app.translator.trans('core.forum.composer_discussion.title')}</h3>, 100);

    items.replace(
      'discussionTitle',
      <h3>
        <input
          className="FormControl"
          bidi={this.title}
          data-some="1"
          minlength="20"
          maxlength="80"
          placeholder={this.attrs.titlePlaceholder}
          disabled={!!this.attrs.disabled}
          onkeydown={this.onkeydown.bind(this)}
          required="required"
        />
      </h3>
    );

    return items;
  });

  override(DiscussionComposer.prototype, 'onsubmit', function (original) {
    const title = this.composer.fields.title().trim();
    const content = this.composer.fields.content();
    let hasErrors = false;
    // console.log(this.composer.fields, title.trim(), title.trim().endsWith('?'), content);

    if (title.length === 0) {
      app.alerts.show({ type: 'error' }, app.translator.trans('tolyod-advdiscus.forum.validation.title.required'));
      hasErrors = true;
    }
    if (!title.endsWith('?')) {
      app.alerts.show({ type: 'error' }, app.translator.trans('tolyod-advdiscus.forum.validation.title.ends_with'));
      hasErrors = true;
    }
    if (title.length < 20) {
      app.alerts.show({ type: 'error' }, app.translator.trans('tolyod-advdiscus.forum.validation.title.min'));
      hasErrors = true;
    }
    if (title.length > 80) {
      app.alerts.show({ type: 'error' }, app.translator.trans('tolyod-advdiscus.forum.validation.title.min'));
      hasErrors = true;
    }

    if (hasErrors) {
      return;
    }

    original();
  });


  // extend(TextEditor.prototype, "controlItems", function(items) {
  //   console.log(items);
  // });

  // override(IndexPage.prototype, "newDiscussionAction", function () {
  //   return new Promise((resolve, reject) => {
  //     if (app.session.user) {
  //       app.composer.load(DiscussionComposer, { user: app.session.user });
  //       app.composer.show();
  //       app.composer.fullScreen();

  //       return resolve(app.composer);
  //     } else {
  //       app.modal.show(LogInModal);

  //       return reject();
  //     }
  //   });
  // });
}
